import { makeStyles } from '@material-ui/core/styles';

export default () =>{
    let useStyles = makeStyles({ 
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 0px !important',
            '& > span': {
                fontSize: 20,
                fontWeight: 700
            }
        }
    })
    return useStyles();
}